<template>
  <div id="removeclass">
    <modal
      :modal-id="modalId"
      :title="modalTitle"
      :preloader="preloader"
      @submit="submit"
      @close-modal="closeModal"
    >
      <template slot="body">
        <app-overlay-loader v-if="preloader" />
        <form
          class="mb-0"
          :class="{ 'loading-opacity': preloader }"
          ref="form"
          :data-url="selectedUrl ? `crud/${inputs.id}` : addurl">
          <div class="form-group row align-items-center">
            <div class="col-lg-12 col-md-12 col-sm-12 mb-0">
              <label for="inputs_name" >
                {{ $t("title") }}
              </label>
              <app-input
                id="title"
                type="text"
                placeholder="Enter Title"
                v-model="inputs.title"
                :required="true"
              />
            </div>
          </div>
          <div class="form-group row align-items-center" v-if="showEditor == true">
            <div class="col-lg-12 col-md-12 col-sm-12 mb-0">
              <label for="inputs_includes">
                {{ $t("includes") }}
              </label>
              <!-- <app-input
                type="multi-select"
                :list="includes"
                :isAnimatedDropdown="true"
                :required="true"
                v-model="inputs.includes"
              /> -->
              <app-input
                id="inputs_includes"
                type="text-editor"
                v-model="inputs.includes"
                :required="true"
              />
            </div>
          </div>
          <div class="form-group row align-items-center">
            <div class="col-lg-12 col-md-12 col-sm-12 mb-0">
              <label for="inputs_amount">
                {{ $t("amount") }}
              </label>
              <app-input
                id="inputs_amount"
                type="number"
                placeholder="Enter Amount"
                v-model="inputs.amount"
                :required="true"
              />
            </div>
          </div>
          <div class="form-group row align-items-center">
            <div class="col-lg-6 col-md-6 col-sm-12 mb-0">
              <label for="inputs_status">
                {{ $t("period") }}
              </label>
                <app-input
                  id="period"
                  type="number"
                  placeholder="Enter Time Period In Numaric"
                  v-model="inputs.period"
                  :required="true"
                />
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12 mb-0" style="margin-top: 2rem">
              <app-input
                id="inputs_status"
                type="select"
                :required="true"
                v-model="inputs.duration"
                :list="duration"
              />
            </div>
          </div>
          <div class="form-group row align-items-center">
            <div class="col-lg-12 col-md-12 col-sm-12 mb-0">
              <label for="inputs_role">
                {{ $t("role") }}
              </label>
              <app-input
                id="inputs_role"
                type="select"
                :required="true"
                v-model="inputs.role"
                :list="role"
              />
            </div>
          </div>
          <div class="form-group row align-items-center" v-if="showCourseSelection">
            <div class="col-lg-12 col-md-12 col-sm-12 mb-0">
              <label for="inputs_course_ids">
                {{ $t("courses") }}
              </label>
              <app-input
                id="inputs_course_ids"
                type="multi-select"
                :isAnimatedDropdown="true"
                :list="courses"
                v-model="inputs.course_ids"
                :placeholder="$t('courses')"
              />
              <small class="text-muted font-italic">
                {{ $t("selected_courses_will_be_issued_to_company_after_package_purchase") }}
              </small>
            </div>
          </div>
          <div class="form-group row mb-0">
            <div class="col-lg-6 col-md-6 col-sm-12 mb-0">
              <label >
                {{ $t("logo") }}
              </label>
                <app-input
                  type="custom-file-upload"
                  :label="$t('upload_your_file')"
                  v-model="inputs.package_badge"
                  :required="true"
                />
                <small class="text-muted font-italic">
                  {{ $t("recommended_custom_file_validation") }}
                </small>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12 mb-0">
              <label>
                {{ $t("background_image") }}
              </label>
              <app-input
                type="custom-file-upload"
                :label="$t('upload_your_file')"
                v-model="inputs.background_image"
                :required="true"
              />
              <small class="text-muted font-italic">
                {{ $t("recommended_custom_file_validation") }}
              </small>
            </div>
          </div>
        </form>
      </template>
    </modal>
  </div>
</template>

<script>
import { FormMixin } from "../../../../../core/mixins/form/FormMixin";
import { ModalMixin } from "../../../../../app/Mixins/ModalMixin";
import { axiosPost, axiosGet } from "../../../../Helpers/AxiosHelper";
import { PACKAGE_STORE, PACKAGE_UPDATE, PACKAGE_INCLUDE_LIST, CERTIFICATE_COURSE_OPTIONS } from "../../../../Config/ApiUrl";
import AppLibrary from "../../../../Helpers/AppLibrary";

export default {
  name: "PackageAddModal",
  extends: AppLibrary,
  mixins: [FormMixin, ModalMixin],
  props: {
    tableId: String,
  },
  data() {
    return {
      showEditor: false,
      addurl:PACKAGE_STORE,
      preloader: false,
      inputs: {},
      courses: [],
      duration: [
        { id: "", value: "Choose One" },
        { id: "Day", value: "Day" },
        { id: "Week", value: "Weeks" },
        { id: "Month", value: "Month" },
        { id: "Year", value: "Year" },
      ],
      role: [
        { id: "", value: "Select Role For Package" },
        { id: "Buyer", value: "Buyer" },
        { id: "Supplier", value: "Supplier" },
        { id: "Screening Portal", value: "Screening Portal" },
        { id: "Training Portal", value: "Training Portal" },
        { id: "Both", value: "Both" },
      ],
      includes: [
        // { id: "Emails", value: "Emails" },
        // { id: "Accounts", value: "Accounts" },
        // { id: "Notifications", value: "Notifications" },
      ],
      modalId: "demo-add-edit-Modal",
      modalTitle: this.$t("add"),
    }
  },
  computed: {
    showCourseSelection() {
      return ["Training Portal", "Screening Portal"].includes(this.inputs.role);
    }
  },
  created() {
    if (this.selectedUrl) {
      this.modalTitle = this.$t("edit");
      this.preloader = true;
    }
  },
  methods: {
    submit() {

      // this.preloader = true;
      if (this.modalTitle == "Edit") {
        if (typeof this.inputs.package_badge['url'] != 'undefined') {
            this.inputs.type = 'old_file';
        }
        else {
            this.inputs.type = 'new_file';
        }
        if(typeof this.inputs.background_image['url'] != 'undefined') {
          this.inputs.backgroundtype = 'old_background';
        }
        else {
          this.inputs.backgroundtype = 'new_background';
        }
      }

      let formData = new FormData();
        Object.keys(this.inputs).forEach((key) => {
          formData.append(key,this.inputs[key]);
        });

      if (this.modalTitle == "Edit") {
        this.preloader = true;
        // let split = this.selectedUrl.split("/");
        // this.inputs.task_id = split[6];
        axiosPost(PACKAGE_UPDATE, formData)
          .then((res) => {
            
            this.$toastr.s(res.data.type);
          })
          .catch((error) => {
            
            this.$toastr.e(error);
          })
          .finally(() => {
            this.preloader = false;
            $("#demo-add-edit-Modal").modal("hide");
            this.$hub.$emit("reload-" + this.tableId);
          });
      } else {
        // axiosPost(PACKAGE_STORE, formData)
        //   .then((res) => {
        //     
        //     this.$toastr.s(res.data.type);
        //   })
        //   .catch((error) => {
        //     
        //     this.$toastr.e(error);
        //   })
        //   .finally(() => {
        //     this.preloader = false;
        //     $("#demo-add-edit-Modal").modal("hide");
        //     this.$hub.$emit("reload-" + this.tableId);
        //   });
          this.save(formData);
      }
    },
    afterSuccess(response) {
      this.$toastr.s(response.data.type);
      this.$hub.$emit("reload-" + this.tableId);
    },

    afterSuccessFromGetEditData(response) {
      // if (response.data.phone) this.phone = response.data.phone;
      this.inputs = response.data;
      this.inputs.course_ids = response.data.course_ids || [];
      this.showEditor = true;
      // this.inputs.includes = response.data.include;
      this.preloader = false;
    },
    getIncludes() {
      axiosGet(PACKAGE_INCLUDE_LIST)
        .then((res) => {
          
          this.includes = res.data;
        })
        .catch((error) => {
          
        });
    },
    getCourses() {
      axiosGet(CERTIFICATE_COURSE_OPTIONS)
        .then((res) => {
          this.courses = res.data;
        })
        .catch((error) => {
          
        });
    },
  },
  mounted() {
    this.getIncludes();
    this.getCourses();
    $(function () {
      $("#removeclass .modal-dialog ").removeClass("modal-dialog-scrollable");
    });
  },
};
</script>
